/**
 * Created by vanessat on 5/24/17.
 */

define (function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var KEYS = {
        SEATS: "seats"
    };

    var NAME = "NumberOfSeatsModel";

    var NumberOfSeatsModel = {};

    LE.module('LEUserManagement', function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        NumberOfSeatsModel = BaseModel.extend({
            resource: ApiResources.UserManagement.NumberOfSeats,
            name: NAME,
            KEYS: KEYS,

            getSeats: function() {
                return this.get(KEYS.SEATS);
            },

            parse: function (response, options) {

                if (response.provisioning && response.provisioning.seats) {
                    this.set(KEYS.SEATS, response.provisioning.seats);
                }
            }
        });

    });

    return NumberOfSeatsModel;

});

